const SESSION_TOKEN_KEY = 'noteician_session_token';
// Legacy bearer credentials are only enabled after the server explicitly says
// that the old auth system is active. New sessions are always HttpOnly cookies.
let legacyBearerEnabled = false;
export const setAuthMode = enabled => { legacyBearerEnabled = !enabled; };
export const isModernAuthEnabled = () => !legacyBearerEnabled;

const inferApiBaseUrlFromHost = () => {
  if (typeof window === 'undefined') return '';
  return {
    'snd-app-production.pages.dev': '/api-proxy',
    'app.noteician.com': 'https://api.noteician.com',
    'snd-app-staging.pages.dev': '/api-proxy',
  }[window.location.hostname] || '';
};

export const getStoredSessionToken = () => {
  try { return window.localStorage.getItem(SESSION_TOKEN_KEY) || ''; } catch (_) { return ''; }
};
export const setStoredSessionToken = token => {
  try {
    if (token) window.localStorage.setItem(SESSION_TOKEN_KEY, token);
    else window.localStorage.removeItem(SESSION_TOKEN_KEY);
  } catch (_) { /* Cookies work even when browser storage is unavailable. */ }
};

export const buildApiUrl = path => {
  if (/^https?:\/\//i.test(path)) return path;
  const base = (process.env.REACT_APP_API_BASE_URL || inferApiBaseUrlFromHost()).replace(/\/+$/, '');
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
};

export const apiFetch = (path, options = {}) => {
  const headers = new Headers(options.headers || {});
  const token = legacyBearerEnabled ? getStoredSessionToken() : '';
  if (token && !headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
  return fetch(buildApiUrl(path), { credentials: 'include', ...options, headers });
};
